import { PropsWithChildren } from 'react'
import { FormWizardContext } from './context'
import { FormPreview } from './FormPreview'
import { useFormWizardData } from './hooks'
import { StageModal } from './StageModal'
import { FormWizardProps } from './types'

export const FormWizard = ({
  patientId,
  assessmentId,
  form,
  data,
  corrections,
  onSubmit,
  stageId,
  selectStage,
  adminView,
  getStoragePath,
  renderStage,
  withPreview,
  readOnly,
  ReadOnlyFooter,
  children,
  inputSize,
}: PropsWithChildren<FormWizardProps>) => {
  const formWizardData = useFormWizardData(
    patientId,
    assessmentId,
    form,
    data,
    corrections,
    onSubmit,
    stageId,
    selectStage,
    renderStage,
    readOnly,
    ReadOnlyFooter,
    getStoragePath,
    adminView,
    inputSize,
  )
  const { stage } = formWizardData
  return (
    <FormWizardContext.Provider value={formWizardData}>
      {stage ? <StageModal /> : null}
      {withPreview ? (
        <FormPreview
          corrections={corrections ?? {}}
          onStageEdit={formWizardData.open}
          form={form}
          readOnly={readOnly}
          data={data}>
          {children}
        </FormPreview>
      ) : null}
    </FormWizardContext.Provider>
  )
}
